import { Organization } from "@/models/organization.model";
import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class OrganizationsRest {
  getOrganizations(params: QueryParams): Observable<any> {
    const url: string = `/organization`;
    return api.get(url, params);
  }
  getOrganizationById(id: string): Observable<any> {
    const url: string = `/organization/${id}`;
    return api.get(url);
  }
  postOrganization(data: Organization): Observable<any> {
    const url: string = `/organization`;
    return api.post(url, data);
  }
  putOrganization(id: string, data: Organization): Observable<any> {
    const url: string = `/organization/${id}`;
    return api.put(url, data);
  }
}
